// import { useState } from 'react';
// import { suppliersApi } from '../api';
// import { useData, submitForm, useSubmit } from '../hooks/useData';
// import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn } from '../components/common';

// const EMPTY = { full_name: '', phone: '', delivery_info: '', remarks: '' };

// export default function SuppliersPage() {
//   const { data, loading, reload } = useData(suppliersApi.list);
//   const [modal, setModal] = useState(null);
//   const [form, setForm]   = useState(EMPTY);
//   const openAdd  = ()    => { setForm(EMPTY); setModal('add'); };
//   const openEdit = (row) => { setForm(row);   setModal('edit'); };
//   const close    = ()    => setModal(null);
//   const set      = e     => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
//   const handleSave = () => {
//     if (modal === 'add') doSubmit(() => suppliersApi.create(form), 'Supplier added', reload, close);
//     else doSubmit(() => suppliersApi.update(form.id, form), 'Supplier updated', reload, close);
//   };
//   return (
//     <div>
//       <PageHeader title="Suppliers" subtitle="Manage your supplier directory"
//         action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ Add Supplier</button>} />
//       <div className="card">
//         {loading ? <Spinner /> : (
//           <div className="table-wrap">
//             {data.length === 0 ? <Empty msg="No suppliers yet" /> : (
//               <table className="responsive-table">
//                 <thead><tr><th>Name</th><th>Phone</th><th>Delivery Info</th><th>Status</th><th>Actions</th></tr></thead>
//                 <tbody>{data.map(r => (
//                   <tr key={r.id}>
//                     <td data-label="Name" className="td-primary">{r.full_name}</td>
//                     <td data-label="Phone" className="font-mono">{r.phone}</td>
//                     <td data-label="Delivery Info" className="text-muted">{r.delivery_info || '—'}</td>
//                     <td data-label="Status"><span className={`badge ${r.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>{r.active_yes_no ? 'Active' : 'Inactive'}</span></td>
//                     <td data-label="Actions"><div className="action-cell">
//                       <EditBtn onClick={() => openEdit(r)} />
//                       {r.active_yes_no === 1 && <CancelBtn onClick={() => submitForm(() => suppliersApi.deactivate(r.id), 'Deactivated', reload)} />}
//                     </div></td>
//                   </tr>
//                 ))}</tbody>
//               </table>
//             )}
//           </div>
//         )}
//       </div>
//       {modal && (
//         <Modal title={modal === 'add' ? 'Add Supplier' : 'Edit Supplier'} onClose={close}
//           footer={<><button className="btn btn-secondary" onClick={close}>Cancel</button><button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></>}>
//           <div className="form-row form-row-2">
//             <Field label="Full Name" required><input type="text" name="full_name" value={form.full_name} onChange={set} autoFocus /></Field>
//             <Field label="Phone" required><input type="tel" name="phone" value={form.phone} onChange={set} /></Field>
//           </div>
//           <Field label="Delivery Information"><textarea name="delivery_info" value={form.delivery_info || ''} onChange={set} rows={2} /></Field>
//           <Field label="Remarks"><textarea name="remarks" value={form.remarks || ''} onChange={set} rows={2} /></Field>
//           {modal === 'edit' && (
//             <Field label="Status">
//               <select name="active_yes_no" value={form.active_yes_no} onChange={e => setForm(f => ({ ...f, active_yes_no: Number(e.target.value) }))}>
//                 <option value={1}>Active</option><option value={0}>Inactive</option>
//               </select>
//             </Field>
//           )}
//         </Modal>
//       )}
//     </div>
//   );
// }
import { useState } from 'react';
import { suppliersApi } from '../api';
import { useData, submitForm, useSubmit } from '../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn } from '../components/common';

const EMPTY = { full_name: '', phone: '', delivery_info: '', remarks: '' };

export default function SuppliersPage() {
  const { data, loading, reload } = useData(suppliersApi.list);
  const [modal, setModal]   = useState(null);
  const [form, setForm]     = useState(EMPTY);
  const [doSubmit, saving]  = useSubmit();

  const openAdd  = ()    => { setForm(EMPTY); setModal('add'); };
  const openEdit = (row) => { setForm(row);   setModal('edit'); };
  const close    = ()    => setModal(null);
  const set      = e     => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSave = () => {
    if (modal === 'add') doSubmit(() => suppliersApi.create(form), 'Supplier added', reload, close);
    else doSubmit(() => suppliersApi.update(form.id, form), 'Supplier updated', reload, close);
  };

  return (
    <div>
      <PageHeader title="Suppliers" subtitle="Manage your supplier directory"
        action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ Add Supplier</button>} />
      <div className="card">
        {loading ? <Spinner /> : (
          <div className="table-wrap">
            {data.length === 0 ? <Empty msg="No suppliers yet" /> : (
              <table className="responsive-table">
                <thead><tr><th>Name</th><th>Phone</th><th>Delivery Info</th><th>Status</th><th>Actions</th></tr></thead>
                <tbody>{data.map(r => (
                  <tr key={r.id}>
                    <td data-label="Name" className="td-primary">{r.full_name}</td>
                    <td data-label="Phone" className="font-mono">{r.phone}</td>
                    <td data-label="Delivery Info" className="text-muted">{r.delivery_info || '—'}</td>
                    <td data-label="Status"><span className={`badge ${r.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>{r.active_yes_no ? 'Active' : 'Inactive'}</span></td>
                    <td data-label="Actions"><div className="action-cell">
                      <EditBtn onClick={() => openEdit(r)} />
                      {r.active_yes_no === 1 && <CancelBtn onClick={() => submitForm(() => suppliersApi.deactivate(r.id), 'Deactivated', reload)} />}
                    </div></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}
      </div>
      {modal && (
        <Modal title={modal === 'add' ? 'Add Supplier' : 'Edit Supplier'} onClose={close}
          footer={<><button className="btn btn-secondary" onClick={close}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></>}>
          <div className="form-row form-row-2">
            <Field label="Full Name" required><input type="text" name="full_name" value={form.full_name} onChange={set} autoFocus /></Field>
            <Field label="Phone" required><input type="tel" name="phone" value={form.phone} onChange={set} /></Field>
          </div>
          <Field label="Delivery Information"><textarea name="delivery_info" value={form.delivery_info || ''} onChange={set} rows={2} /></Field>
          <Field label="Remarks"><textarea name="remarks" value={form.remarks || ''} onChange={set} rows={2} /></Field>
          {modal === 'edit' && (
            <Field label="Status">
              <select name="active_yes_no" value={form.active_yes_no} onChange={e => setForm(f => ({ ...f, active_yes_no: Number(e.target.value) }))}>
                <option value={1}>Active</option><option value={0}>Inactive</option>
              </select>
            </Field>
          )}
        </Modal>
      )}
    </div>
  );
}